import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import * as Yup from "yup";
import { useFormik, Formik, Form, Field, ErrorMessage } from "formik";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  Tooltip,
  NavLink,
} from "reactstrap";
import Switch from "react-switch";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";

import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
function InvestorDetail() {
  const api = Config.backOffice.apiName;
  const backUrl = Config.backOffice.url;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const [loading, setLoading] = useState(true);
  const [wait, setWait] = useState(1000);
  const token = localStorage.getItem("auth_token_" + api);
  const [investisseursData, setInvestisseursData] = useState([]);
  //meta title

  const [comments, setComments] = useState(""); // Commentaire
  const [nom, setNom] = useState(""); // Nom
  const [prenom, setPrenom] = useState(""); // Prenom
  const [dateNaissance, setDateNaissance] = useState(""); // date de naissance
  const [villeNaissance, setVilleNaissance] = useState(""); // ville de naissance
  const smartCapitalizeWithDash = (word, originalWord) => {
    return word
      .split("-")
      .map((subWord, subIndex) => {
        const originalSubWord = originalWord.split("-")[subIndex] || "";

        // Préserve les majuscules existantes
        return subWord
          .split("")
          .map((char, charIndex) => {
            const originalChar = originalSubWord[charIndex];
            if (originalChar && originalChar === originalChar.toUpperCase()) {
              return char.toUpperCase();
            }
            return charIndex === 0 ? char.toUpperCase() : char.toLowerCase();
          })
          .join("");
      })
      .join("-");
  };

  const handleParenthesis = (word, originalWord) => {
    // Gérer les parenthèses comme "Casablanca (Maroc)"
    if (word.includes("(") && word.includes(")")) {
      const mainPart = word.substring(0, word.indexOf("(")).trim();
      const parenthesisPart = word.substring(
        word.indexOf("(") + 1,
        word.indexOf(")")
      );
      const afterParenthesis = word.substring(word.indexOf(")") + 1);

      // Parties originales pour préserver majuscules
      const originalMainPart = originalWord
        .substring(0, originalWord.indexOf("("))
        .trim();
      const originalParenthesisPart = originalWord.substring(
        originalWord.indexOf("(") + 1,
        originalWord.indexOf(")")
      );

      const capitalizedMain = smartCapitalizeWithDash(
        mainPart,
        originalMainPart
      );
      const capitalizedParenthesis = smartCapitalizeWithDash(
        parenthesisPart,
        originalParenthesisPart
      );

      return `${capitalizedMain} (${capitalizedParenthesis})${afterParenthesis}`;
    }
    return smartCapitalizeWithDash(word, originalWord);
  };
  const handleVilleNaissanceChange = (e) => {
    const rawValue = e.target.value;

    // Utilise une regex pour capitaliser chaque mot
    const transformedValue = rawValue.toLowerCase().replace(/\b\w/g, (char) => {
      return char.toUpperCase();
    });

    console.log(transformedValue);
    setVilleNaissance(transformedValue);
  };

  const [depNaissance, setDepNaissance] = useState(""); // departement de naissance
  const [profession, setProfession] = useState(""); // profession
  const [adresse, setAdresse] = useState(""); // adresse
  // tableau adresse postales PP
  const [complement, setComplement] = useState(""); // complement
  const [codePostal, setCodePostal] = useState(""); // code postal
  const [ville, setVille] = useState(""); // ville
  const [telFixe, setTelFixe] = useState(""); // tel fixe
  // tableau adresse email
  const [email, setEmail] = useState("");
  // tableau numéros de téléphone
  const [numero, setNumero] = useState("");

  const [courrier, setCourrier] = useState(""); //Courrier
  const [titre, setTitre] = useState(""); // Titre
  // PM
  const [denomSocial, setDenomSocial] = useState(""); // Denomination social
  const [numeroRcs, setNumeroRcs] = useState(""); // Numéro RCS
  const [telephone, setTelephone] = useState(""); // Telephone
  const [fax, setFax] = useState(""); // Fax
  const [emailPm, setEmailPm] = useState(""); // email PM
  const [canEditInvestor, setCanEditInvestor] = useState(true);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  /*************************   Statut *******************************/
  const [statutData, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }
  const capitalizeWordWithDash = (word) => {
    return word
      .split("-")
      .map(
        (subWord) =>
          subWord.charAt(0).toUpperCase() + subWord.slice(1).toLowerCase()
      )
      .join("-");
  };

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/investisseurs/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.status);
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      // if (!response.ok) {
      //   localStorage.removeItem("auth_token_"+api);
      //   localStorage.removeItem("authUser_"+api);
      //   localStorage.removeItem("sideBar_"+api);
      //   history('/backoffice_test/login');
      //   window.location.reload(false);
      //   // throw new Error("Erreur lors de la récupération des données");
      //   // rediriger vers le login
      // }

      const investisseursData = await response.json();
      setInvestisseursData(investisseursData);
      if (investisseursData?.can_modify_investisseur == true) {
        setCanEditInvestor(true);
      } else {
        setCanEditInvestor(false);
        setActiveTab("contact");
      }
      setSelectedStatut(
        investisseursData?.detail_investisseur?.identification.Statut
      );
      setSelectedConseil(
        investisseursData?.detail_investisseur?.identification.Partenaire
      );
      setSelectedCourrier(
        investisseursData?.detail_investisseur?.identification.Courrier
      );
      setSelectedCsp(
        investisseursData?.detail_investisseur?.identification.Csp
      );
      if (investisseursData?.detail_investisseur?.identification.Type == "PP") {
        setNom(investisseursData?.detail_nom_investisseur?.identification.Nom);
        setPrenom(
          investisseursData?.detail_nom_investisseur?.identification.Prénom
        );
        setSelectedTitre(
          investisseursData?.detail_nom_investisseur?.identification.Titre
        );
        setSelectedSociete(
          investisseursData?.detail_nom_investisseur?.identification.Société
        );
        setDateNaissance(
          formatDateToFrench(
            investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
              "Date de naissance"
            ]
          )
        );
        setVilleNaissance(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Ville de naissance"
          ]
        );
        setDepNaissance(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Code département de naissance"
          ]
        );
        setProfession(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Profession"
          ]
        );
        setSelectedSituationMatrimoniale(
          investisseursData?.detail_nom_investisseur?.renseignements_divers?.[
            "Situation matrimoniale"
          ]
        );
        setFormAdressePostals(
          investisseursData?.detail_nom_investisseur?.adresses_postales
            ?.Adresses.data
        );
        setFormAdresseEmails(
          investisseursData?.detail_nom_investisseur?.adresses_email?.Emails
            .data
        );
        setFormNumeroTelephones(
          investisseursData?.detail_nom_investisseur?.numeros_de_telephone?.[
            "Téléphones"
          ].data
        );
      }
      if (investisseursData?.detail_investisseur?.identification.Type == "PM") {
        setFormAdressePostals(
          investisseursData?.detail_nom_investisseur?.adresses?.Adresses.data
        );
        setSelectedForme(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Forme juridique"
          ]
        );
        setSelectedPresidentPP(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Président (PP)"
          ]
        );
        setSelectedPresidentPM(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Président (PM)"
          ]
        );
        setSelectedDir(
          investisseursData?.detail_nom_investisseur?.caracteristiques?.[
            "Directeur Général"
          ]
        );
        setDenomSocial(
          investisseursData?.detail_nom_investisseur?.identification?.[
            "Dénomination sociale"
          ]
        );
        setNumeroRcs(
          investisseursData?.detail_nom_investisseur?.identification?.["N° RCS"]
        );
        setTelephone(
          investisseursData?.detail_nom_investisseur?.contact?.["Téléphone"]
        );
        setFax(investisseursData?.detail_nom_investisseur?.contact?.["Fax"]);
        setEmailPm(
          investisseursData?.detail_nom_investisseur?.contact?.["Email"]
        );
      }

      setComments(investisseursData?.detail_investisseur?.details.Commentaires);
      setTitre(
        investisseursData?.detail_nom_investisseur?.identification.Titre
      );
    } catch (error) {
      console.error(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/statut_investisseurs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((statut) => {
          setStatutData(statut);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Statut *******************************/

  /*************************   Conseil  *******************************/

  const [conseilData, setConseilData] = useState({ data: [] });
  const [selectedConseil, setSelectedConseil] = useState("");
  const renderConseilOptions = () => {
    return [
      {
        options: conseilData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleConseilChange = (e) => {
    setSelectedConseil(e);
  };
  const getConseil = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/partenaires`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((conseil) => {
          setConseilData(conseil);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Conseil *******************************/
  /*************************   Courrier  *******************************/
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  const courrierData = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const [selectedCourrier, setSelectedCourrier] = useState("");

  const [selectedYesNo, setSelectedYesNo] = useState("");
  const renderYesNoOptions = () => {
    return [
      <option key="" value=""></option>,
      ...courrierData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const handleYesNoChange = (e) => {
    setSelectedYesNo(e.target.value);
  };
  /*************************   END Courrier *******************************/
  /*************************   Titre  *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const [selectedTitre, setSelectedTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const handleTitreChange = (e) => {
    setSelectedTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  /*************************   Societe  *******************************/
  const [societeData, setSocieteData] = useState({ data: [] });
  const [selectedSociete, setSelectedSociete] = useState("");

  const renderSocieteOptions = () => {
    return [
      {
        options: societeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSocieteChange = (e) => {
    setSelectedSociete(e);
  };
  const getSociete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((societe) => {
          setSocieteData(societe);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Societe *******************************/
  /*************************   Csp  *******************************/
  const [cspData, setCspData] = useState({ data: [] });
  const [selectedCsp, setSelectedCsp] = useState("");
  const renderCspOptions = () => {
    return [
      <option key="" value=""></option>,
      ...cspData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const handleCspChange = (e) => {
    setSelectedCsp(e.target.value);
  };
  const getCsp = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/csps`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((csp) => {
          setCspData(csp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Csp *******************************/
  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [selectedSituationMatrimoniale, setSelectedSituationMatrimoniale] =
    useState("");

  const renderSituationMatrimonialeOptions = () => {
    return [
      {
        options: situationMatrimonialeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSelectedSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  /*************************   TypesAdress  *******************************/
  const [typesAdressData, setTypesAdressData] = useState({ data: [] });
  const [activeTab, setActiveTab] = useState(
    history?.state?.usr?.active || (canEditInvestor ? "details" : "contact")
  ); // État pour contrôler l'affichage
  const renderTypesAdressOptions = () => {
    return [
      <option key="" value=""></option>,
      ...typesAdressData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const getTypesAdress = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/types_adresss`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((typesAdress) => {
          setTypesAdressData(typesAdress);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END TypesAdress *******************************/
  /*************************   TypesTelephone  *******************************/
  const [typesTelephoneData, setTypesTelephoneData] = useState({ data: [] });
  const renderTypesTelephoneOptions = () => {
    return [
      <option key="" value=""></option>,
      ...typesTelephoneData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const getTypesTelephone = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/types_telephones`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((typesTelephone) => {
          setTypesTelephoneData(typesTelephone);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END TypesTelephone *******************************/

  /*************************   TypesEmail  *******************************/
  const [typesEmailData, setTypesEmailData] = useState({ data: [] });
  const renderTypesEmailOptions = () => {
    return [
      <option key="" value=""></option>,
      ...typesEmailData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };

  const getTypesEmail = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/types_emails`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((typesEmail) => {
          setTypesEmailData(typesEmail);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /*************************   END TypesEmail *******************************/

  /*************************   Pays  *******************************/
  const [payData, setPayData] = useState({ data: [] });
  const renderPayOptions = () => {
    const emptyOption = (
      <option key="empty" value="">
        Sélectionner une option
      </option>
    );

    return [
      emptyOption,
      ...payData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/
  /*************************   Formes juridiques         *******************************/
  const [formeJuridique, setFormeJuridique] = useState({ data: [] });
  const [selectedForme, setSelectedForme] = useState("");
  const renderFormeOptions = () => {
    return [
      {
        options: formeJuridique.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleFormeChange = (e) => {
    setSelectedForme(e);
  };
  const getFormeJuri = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/formes_juridiques`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((formeJuridique) => {
          setFormeJuridique(formeJuridique);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Formes juridiques         *******************************/

  /*************************   Président PM          *******************************/
  const [presidentData, setPresidentData] = useState({ data: [] });
  const [selectedPresidentPM, setSelectedPresidentPM] = useState("");
  const [selectedPresidentPP, setSelectedPresidentPP] = useState("");

  const renderPresidentOptions = () => {
    return [
      {
        options: presidentData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handlePresidentChange = (e) => {
    setSelectedPresidentPM(e);
  };
  const handlePresidentPPChange = (e) => {
    setSelectedPresidentPP(e);
  };
  const getPresident = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes2`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((president) => {
          setPresidentData(president);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END President         *******************************/

  /*************************   Directeur          *******************************/
  const [directeurData, setDirecteurData] = useState({ data: [] });
  const [selectedDir, setSelectedDir] = useState("");
  const renderDirecteurOptions = () => {
    return [
      {
        options: directeurData.data.map((dataItem) => ({
          label: dataItem.label,
          id: dataItem.id,
        })),
      },
    ];
  };
  const handleDirecteurChange = (e) => {
    setSelectedDir(e);
  };
  const getDirecteur = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/contacts`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((directeur) => {
          setDirecteurData(directeur);
          setWait(0);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Directeur         *******************************/

  /******************************* HMF adresses postales *******************************************/
  const [formAdressePostals, setFormAdressePostals] = useState({});

  const onAddFormAdressePostal = () => {
    const modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals.push({
      index: modifiedAdressePostals.length + 1,
      id: null,
      // principale: null,
      // types_adress_id: null,
      adresse: null,
      complement: null,
      code_postal: null,
      ville: null,
      pay_id: null,
      tel_fixe: null,
    });
    setFormAdressePostals(modifiedAdressePostals);
  };

  const onDeleteFormAdressePostal = (id) => {
    var modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals = modifiedAdressePostals.filter(
      (x) => x["index"] !== id
    );
    setFormAdressePostals(modifiedAdressePostals);
  };
  /******************************* END HMF adresses postales *******************************************/

  /******************************* HMF adresses postales PM *******************************************/

  const onAddFormAdressePostalPM = () => {
    const modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals.push({
      index: modifiedAdressePostals.length + 1,
      id: null,
      siege: null,
      adresse: null,
      complement: null,
      code_postal: null,
      ville: null,
      pay_id: null,
      tel: null,
    });
    setFormAdressePostals(modifiedAdressePostals);
  };

  const onDeleteFormAdressePostalPM = (id) => {
    var modifiedAdressePostals = [...formAdressePostals];
    modifiedAdressePostals = modifiedAdressePostals.filter(
      (x) => x["index"] !== id
    );
    setFormAdressePostals(modifiedAdressePostals);
  };
  const handleInputChange = (index, field, value) => {
    console.log("ID:", index);
    console.log("Field:", field);
    console.log("Value:", value);

    const modifiedAdressePostals = formAdressePostals.map((adressePostal) => {
      if (adressePostal.index === index) {
        return {
          ...adressePostal,
          [field]: value,
        };
      }
      return adressePostal;
    });

    setFormAdressePostals(modifiedAdressePostals);
  };
  /******************************* END HMF adresses postales *******************************************/
  /******************************* HMF adresses emails *******************************************/
  const [formAdresseEmails, setFormAdresseEmails] = useState({});

  const onAddFormAdresseEmail = () => {
    const modifiedAdresseEmails = [...formAdresseEmails];
    modifiedAdresseEmails.push({
      index: modifiedAdresseEmails.length + 1,
      id: null,
      // types_email_id: null,
      email: null,
    });
    setFormAdresseEmails(modifiedAdresseEmails);
  };

  const onDeleteFormAdresseEmail = (id) => {
    var modifiedAdresseEmails = [...formAdresseEmails];
    modifiedAdresseEmails = modifiedAdresseEmails.filter(
      (x) => x["index"] !== id
    );
    setFormAdresseEmails(modifiedAdresseEmails);
  };
  const handleInputChangeEmail = (id, field, value) => {
    console.log("ID:", id);
    console.log("Field:", field);
    console.log("Value:", value);

    const modifiedAdresseEmails = formAdresseEmails.map((adresseEmail) => {
      if (adresseEmail.index === id) {
        return {
          ...adresseEmail,
          [field]: value,
        };
      }
      return adresseEmail;
    });

    setFormAdresseEmails(modifiedAdresseEmails);
  };
  console.log("Adresse Email", formAdresseEmails);
  /******************************* END HMF adresses emails *******************************************/
  /******************************* HMF adresses telephone *******************************************/
  const [formNumeroTelephones, setFormNumeroTelephones] = useState({});

  const onAddFormNumeroTelephone = () => {
    const modifiedNumeroTelephones = [...formNumeroTelephones];
    modifiedNumeroTelephones.push({
      index: modifiedNumeroTelephones.length + 1,
      id: null,
      // types_telephone_id: null,
      numero: null,
    });
    setFormNumeroTelephones(modifiedNumeroTelephones);
  };

  const onDeleteFormNumeroTelephone = (id) => {
    var modifiedNumeroTelephones = [...formNumeroTelephones];
    modifiedNumeroTelephones = modifiedNumeroTelephones.filter(
      (x) => x["index"] !== id
    );
    setFormNumeroTelephones(modifiedNumeroTelephones);
  };
  const handleInputChangeTelephone = (id, field, value) => {
    console.log("ID:", id);
    console.log("Field:", field);
    console.log("Value:", value);

    const modifiedNumeroTelephones = formNumeroTelephones.map((numeroTel) => {
      if (numeroTel.index === id) {
        return {
          ...numeroTel,
          [field]: value,
        };
      }
      return numeroTel;
    });

    setFormNumeroTelephones(modifiedNumeroTelephones);
  };
  /******************************* END HMF adresses telephone *******************************************/
  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);

    navigate(-1);
  };
  const handleSubmitPP = async (event) => {
    event.preventDefault();
    if (nom === "" && selectedStatut === null) {
      toast.error("Le statut et le nom ne peuvent pas être vide");
    } else if (nom === "") {
      toast.error("Le nom ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investisseurs/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              investisseur: {
                id: id,
                statut_investisseur_id: selectedStatut?.value || "",
                partenaire_id: selectedConseil?.value || "",
                courrier: selectedCourrier ? 1 : 2,
                commentaires: comments,
              },
              contact: {
                nom: nom,
                prenom: prenom,
                // societe_id: selectedSociete?.value || "",
                titre_id: selectedTitre?.value || "",
                date_de_naissance: dateNaissance,
                ville_de_naissance: villeNaissance,
                departement_ou_pays: depNaissance,
                profession: profession,
                situation_matrimoniale_id:
                  selectedSituationMatrimoniale?.value || "",
              },
              contact_hmf_adresses: formAdressePostals.map((obj) => {
                // on retire le champs index
                delete obj.index;
                return obj;
              }),
              contact_hmf_emails: formAdresseEmails.map((obj) => {
                delete obj.index;
                return obj;
              }),
              contact_hmf_telephones: formNumeroTelephones.map((obj) => {
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (
            (responseData && responseData.contact_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors =
              responseData?.contact_validation ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleSubmitPM = async (event) => {
    event.preventDefault();
    if (denomSocial === "" && selectedStatut === null) {
      toast.error(
        "Le statut et la dénomination sociale ne peuvent pas être vide"
      );
    } else if (denomSocial === "") {
      toast.error("La dénomination sociale ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investisseurs/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              investisseur: {
                id: id,
                statut_investisseur_id: selectedStatut?.value || "",
                partenaire_id: selectedConseil?.value || "",
                courrier: selectedCourrier ? 1 : 2,
                commentaires: comments,
                rcs: numeroRcs,
              },
              societe: {
                raison_sociale: denomSocial,
                telephone: telephone,
                fax: fax,
                email: emailPm,
                formes_juridique_id: selectedForme?.value || "",
                societe_id: selectedPresidentPM?.value || "", // Président PM
                contact2_id: selectedDir?.value || selectedDir?.id || "", // directeur
                contact_id:
                  selectedPresidentPP?.value || selectedPresidentPP?.id || "", // Président PP
              },
              societe_hmf_adresses: formAdressePostals.map((obj) => {
                // on retire le champs index
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");

          handleNavigate({ key: true });
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Submit Edit *******************************************/
  /******************************* Validation *******************************************/
  const validationSchema = Yup.object().shape({
    selectedStatut: Yup.string().required("Veuillez sélectionner un statut"),
  });
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        // commun
        await getData();
        await getStatut();
        await getConseil();
        await getPay();
        // if PP
        await getTitre();
        // await getSociete();
        await getCsp();
        await getSituationMatrimoniale();
        await getTypesAdress();
        // await getTypesTelephone();
        await getTypesEmail();
        // if PM
        await getFormeJuri();
        await getPresident();
        await getDirecteur();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
      console.log("test finished");
    }
  }, [wait]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Investisseurs | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        {canEditInvestor && (
          <NavItem>
            <NavLink
              style={navStyle}
              className={`nav-link ${activeTab === "details" ? "active" : ""}`}
              to="#details"
              onClick={() => handleTabClick("details")}
            >
              Détails investisseur
            </NavLink>
          </NavItem>
        )}
        <NavItem>
          <NavLink
            style={navStyle}
            to="#contact"
            onClick={() => handleTabClick("contact")}
            className={`nav-link ${activeTab === "contact" ? "active" : ""}`}
          >
            {!loading ? (
              investisseursData?.detail_investisseur?.identification.Type ==
              "PP" ? (
                "Détails personne physique"
              ) : (
                "Détails personne morale"
              )
            ) : (
              <>
                <h5 className="card-title placeholder-glow">
                  <span
                    style={{ height: "1em" }}
                    className="placeholder col-6"
                  ></span>
                </h5>
              </>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  const renderValue = (value) => {
    if (value == null) {
      return "";
    } else if (typeof value === "string" && value.trim() === "") {
      return "";
    } else if (value === "Validé") {
      return <span className="bg-success badge bg-secondary">{value}</span>;
    } else if (value === "En attente") {
      return <span className="bg-info badge bg-secondary">{value}</span>;
    } else {
      return value;
    }
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/investisseurs/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Investisseurs
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        investisseursData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>
                  {!loading &&
                  investisseursData?.detail_investisseur?.identification.Type ==
                    "PP" ? (
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmitPP} // validation PP
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmitPM} // validation PM
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  )}
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && canEditInvestor && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  {" "}
                                  Identification
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_investisseur
                                      ?.identification
                                  ).map(([key, value], index) => (
                                    <Row className="mb-2" key={index}>
                                      {key === "Statut" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key}* :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              value={
                                                selectedStatut?.label == null
                                                  ? null
                                                  : selectedStatut
                                              }
                                              onChange={handleStatutChange}
                                              options={renderStatutOptions()}
                                              isClearable={true}
                                              className="select2"
                                              styles={styles(
                                                selectedStatut == null
                                              )}
                                            />
                                            {selectedStatut === null ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Statut ne peut pas être vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </>
                                      ) : key === "Courrier" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Switch
                                              uncheckedIcon={<Offsymbol />}
                                              checkedIcon={<OnSymbol />}
                                              onColor="#555B21"
                                              onChange={() => {
                                                setSelectedCourrier(
                                                  !selectedCourrier
                                                );
                                              }}
                                              checked={
                                                selectedCourrier == 1
                                                  ? true
                                                  : false
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Partenaire" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              isDisabled={
                                                type_compte != "builder" &&
                                                type_compte != "admin"
                                                  ? true
                                                  : false
                                              }
                                              value={
                                                selectedConseil?.label == null
                                                  ? null
                                                  : selectedConseil
                                              }
                                              onChange={handleConseilChange}
                                              options={renderConseilOptions()}
                                              isClearable={true}
                                              className="select2"
                                              menuPortalTarget={document.body}
                                              styles={styles(false)}
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Comptes associés" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <span>
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: value,
                                                }}
                                              />
                                            </span>
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <SouscriptionsCard
                                  title="Souscriptions"
                                  details={
                                    investisseursData?.detail_investisseur
                                      ?.souscriptions
                                  }
                                />
                              </Row>
                              <Row>
                                <Card className="mb-4">
                                  <CardTitle tag="h5">Détails</CardTitle>
                                  <CardBody>
                                    <Row className="mb-2">
                                      <Col
                                        key="commentaires"
                                        className="col-4"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "11em",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Commentaires :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col xs={12} md={8} className="col-md-8">
                                        <textarea
                                          className="form-control form-control-sm"
                                          value={
                                            investisseursData
                                              ?.detail_investisseur?.details
                                              .Commentaires
                                          }
                                          style={{
                                            width: "100%",
                                            resize: "vertical",
                                          }}
                                          onChange={(e) =>
                                            setComments(e.target.value)
                                          }
                                        ></textarea>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "contact" && (
                    <div>
                      {!loading &&
                      investisseursData?.detail_investisseur?.identification
                        .Type == "PP" ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Identification
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.identification
                                  ).map(([key, value], index) => (
                                    <Row className="mb-2" key={index}>
                                      {key === "Titre" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              value={
                                                selectedTitre?.label == null
                                                  ? null
                                                  : selectedTitre
                                              }
                                              onChange={handleTitreChange}
                                              options={renderTitreOptions()}
                                              isClearable={true}
                                              className="select2"
                                              isSearchable={false}
                                              placeholder="Titre"
                                              styles={styles(false)}
                                            />
                                          </Col>
                                        </>
                                      ) : // : key === "Société" ? (
                                      //   <>
                                      //     <Col
                                      //       xs={12}
                                      //       md={12}
                                      //       lg={4}
                                      //       style={colStyle}
                                      //     >
                                      //       <i style={{ color: "#9d9c9c" }}>
                                      //         <span>{key} :</span>
                                      //       </i>
                                      //     </Col>
                                      //     <Col className="col-md-6">
                                      //       <Select
                                      //         value={
                                      //           selectedSociete?.label == null
                                      //             ? null
                                      //             : selectedSociete
                                      //         }
                                      //         onChange={handleSocieteChange}
                                      //         options={renderSocieteOptions()}
                                      //         isClearable={true}
                                      //         className="select2"
                                      //         styles={styles(false)}
                                      //       />
                                      //     </Col>
                                      //   </>
                                      // )
                                      key === "Nom" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key}* :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              style={{
                                                textTransform: "uppercase",
                                              }}
                                              value={nom}
                                              required
                                              onChange={(e) =>
                                                setNom(
                                                  e.target.value.toUpperCase()
                                                )
                                              }
                                            />
                                            {nom === "" ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Nom ne peut pas être vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </>
                                      ) : key === "Prénom" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                              value={prenom}
                                              onChange={(e) =>
                                                setPrenom(
                                                  e.target.value
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    e.target.value
                                                      .slice(1)
                                                      .toLowerCase()
                                                )
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            xs={12}
                                            md={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Renseignements Divers
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.renseignements_divers
                                  ).map(([key, value], index) => (
                                    <Row className="mb-2" key={index}>
                                      {key === "Date de naissance" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <InputMask
                                              mask="99/99/9999"
                                              value={dateNaissance}
                                              className="form-control form-control-sm input-color"
                                              onChange={(dateString) => {
                                                setDateNaissance(
                                                  dateString.target.value
                                                );
                                              }}
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Ville de naissance" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              value={villeNaissance}
                                              onChange={
                                                handleVilleNaissanceChange
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key ===
                                        "Code département de naissance" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>
                                                {key}
                                                <i
                                                  className="bx bx-info-circle"
                                                  style={{
                                                    marginLeft: "5px",
                                                    cursor: "pointer",
                                                    color: "black",
                                                    fontSize: "15px",
                                                  }}
                                                  id="CodeDepartementNaissance"
                                                  onMouseEnter={toggleTooltip}
                                                  onMouseLeave={toggleTooltip}
                                                />
                                                <Tooltip
                                                  placement="top"
                                                  isOpen={tooltipOpen}
                                                  target="CodeDepartementNaissance"
                                                  toggle={toggleTooltip}
                                                >
                                                  Saisir le numéro du
                                                  département pour la France et
                                                  le pays en toutes lettres
                                                  lorsque l’investisseur est né
                                                  hors de France.
                                                </Tooltip>{" "}
                                                :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              value={depNaissance}
                                              onChange={(e) =>
                                                setDepNaissance(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Profession" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              value={profession}
                                              onChange={(e) =>
                                                setProfession(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "CSP" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <select
                                              value={selectedCsp}
                                              onChange={handleCspChange}
                                              style={{ maxWidth: "200px" }}
                                            >
                                              {renderCspOptions()}
                                            </select>
                                          </Col>
                                        </>
                                      ) : key === "Situation matrimoniale" ? (
                                        <>
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              value={
                                                selectedSituationMatrimoniale?.label ==
                                                null
                                                  ? null
                                                  : selectedSituationMatrimoniale
                                              }
                                              onChange={
                                                handleSituationMatrimonialeChange
                                              }
                                              options={renderSituationMatrimonialeOptions()}
                                              isClearable={true}
                                              className="select2"
                                              isSearchable={false}
                                              placeholder="Situation matrimoniale"
                                              styles={styles(false)}
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            xs={12}
                                            md={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Card className="mb-4">
                              <CardTitle tag="h5">Adresses</CardTitle>
                              <CardBody>
                                <Col sm="12">
                                  <div className="table-responsive">
                                    <table
                                      className="table table-bordered rounded-3 overflow-hidden"
                                      style={{
                                        borderCollapse: "collapse",
                                        width: "100%",
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          {investisseursData?.detail_nom_investisseur?.adresses_postales?.Adresses.header.map(
                                            (columnName, index) => (
                                              <th
                                                className="text-nowrap"
                                                style={tableaustyles}
                                                key={index}
                                              >
                                                {columnName}
                                              </th>
                                            )
                                          )}
                                          <th
                                            className="text-nowrap"
                                            style={{
                                              background: "#555B21",
                                              color: "white",
                                              paddingTop: "5px",
                                              paddingBottom: "5px",
                                              width: "1%",
                                            }}
                                            key="Del"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {formAdressePostals.map((rowData) => (
                                          <tr key={rowData.index}>
                                            {Object.entries(rowData).map(
                                              ([key, value]) =>
                                                key !== "id" &&
                                                key !== "index" ? (
                                                  <td key={key}>
                                                    {key === "principale" ? (
                                                      <select
                                                        value={value}
                                                        name="principale"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderYesNoOptions()}
                                                      </select>
                                                    ) : key ===
                                                      "types_adress_id" ? (
                                                      <select
                                                        value={value}
                                                        name="types_adress_id"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      >
                                                        {renderTypesAdressOptions()}
                                                      </select>
                                                    ) : key === "adresse" ||
                                                      key === "complement" ||
                                                      key === "code_postal" ||
                                                      key === "ville" ||
                                                      key === "tel_fixe" ? (
                                                      <input
                                                        className="form-control form-control-sm"
                                                        value={value}
                                                        name={key}
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.name ===
                                                              "ville"
                                                              ? e.target.value.toUpperCase()
                                                              : e.target.value
                                                          )
                                                        }
                                                      />
                                                    ) : key === "pay_id" ? (
                                                      <select
                                                        value={value}
                                                        name="pay_id"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderPayOptions()}
                                                      </select>
                                                    ) : (
                                                      <span>{value}</span>
                                                    )}
                                                  </td>
                                                ) : (
                                                  <td
                                                    className="d-none"
                                                    key={key}
                                                  >
                                                    <input
                                                      type="hidden"
                                                      value={value}
                                                    />
                                                  </td>
                                                )
                                            )}
                                            <td>
                                              <i
                                                className="bx bx-trash"
                                                style={{
                                                  fontSize: "20px",
                                                  paddingTop: "5px",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  onDeleteFormAdressePostal(
                                                    rowData.index
                                                  )
                                                }
                                              ></i>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr>
                                          <td colSpan="9">
                                            <input
                                              type="button"
                                              style={tableaustyles}
                                              className="btn btn-info mt-3 mt-lg-0"
                                              value="Ajouter"
                                              onClick={onAddFormAdressePostal}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </Col>
                              </CardBody>
                            </Card>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Emails
                                </CardTitle>

                                <CardBody>
                                  <div className="table-responsive">
                                    <table className="table table-bordered rounded-3 overflow-hidden">
                                      <thead>
                                        <tr>
                                          {investisseursData?.detail_nom_investisseur?.adresses_email?.Emails.header.map(
                                            (columnName, index) => (
                                              <th
                                                className="text-nowrap"
                                                style={tableaustyles}
                                                key={index}
                                              >
                                                {columnName}
                                              </th>
                                            )
                                          )}
                                          <th
                                            className="text-nowrap"
                                            style={{
                                              background: "#555B21",
                                              color: "white",
                                              paddingTop: "5px",
                                              paddingBottom: "5px",
                                              width: "5%",
                                            }}
                                            key="Del"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {formAdresseEmails.map((rowData) => (
                                          <tr key={rowData.index}>
                                            {Object.entries(rowData).map(
                                              ([key, value]) =>
                                                key !== "id" &&
                                                key !== "index" ? (
                                                  <td key={key}>
                                                    {key ===
                                                    "types_email_id" ? (
                                                      <select
                                                        value={value}
                                                        name="types_email_id"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) =>
                                                          handleInputChangeEmail(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderTypesEmailOptions()}
                                                      </select>
                                                    ) : key === "email" ? (
                                                      <input
                                                        className="form-control form-control-sm"
                                                        value={value}
                                                        name="email"
                                                        onChange={(e) =>
                                                          handleInputChangeEmail(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      <span>{value}</span>
                                                    )}
                                                  </td>
                                                ) : (
                                                  <td
                                                    className="d-none"
                                                    key={key}
                                                  >
                                                    <input
                                                      type="hidden"
                                                      size="10"
                                                      value={value}
                                                    />
                                                  </td>
                                                )
                                            )}
                                            <td>
                                              <i
                                                className="bx bx-trash"
                                                style={{
                                                  fontSize: "20px",
                                                  paddingTop: "5px",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  onDeleteFormAdresseEmail(
                                                    rowData.index
                                                  )
                                                }
                                              ></i>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr>
                                          <td colSpan="9">
                                            <input
                                              type="button"
                                              style={tableaustyles}
                                              className="btn btn-info mt-3 mt-lg-0"
                                              value="Ajouter"
                                              onClick={onAddFormAdresseEmail}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Numéros
                                </CardTitle>
                                <CardBody>
                                  <div className="table-responsive">
                                    <table className="table table-bordered rounded-3 overflow-hidden">
                                      <thead>
                                        <tr>
                                          {investisseursData?.detail_nom_investisseur?.numeros_de_telephone?.Téléphones.header.map(
                                            (columnName, index) => (
                                              <th
                                                className="text-nowrap"
                                                style={tableaustyles}
                                                key={index}
                                              >
                                                {columnName}
                                              </th>
                                            )
                                          )}
                                          <th
                                            className="text-nowrap"
                                            style={{
                                              background: "#555B21",
                                              color: "white",
                                              paddingTop: "5px",
                                              paddingBottom: "5px",
                                              width: "5%",
                                            }}
                                            key="Del"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {formNumeroTelephones.map((rowData) => (
                                          <tr key={rowData.index}>
                                            {Object.entries(rowData).map(
                                              ([key, value]) =>
                                                key !== "id" &&
                                                key !== "index" ? (
                                                  <td key={key}>
                                                    {key ===
                                                    "types_telephone_id" ? (
                                                      <select
                                                        value={value}
                                                        name="types_telephone_id"
                                                        onChange={(e) =>
                                                          handleInputChangeTelephone(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      >
                                                        {renderTypesTelephoneOptions()}
                                                      </select>
                                                    ) : key === "numero" ? (
                                                      <input
                                                        className="form-control form-control-sm"
                                                        value={value}
                                                        name="numero"
                                                        onChange={(e) =>
                                                          handleInputChangeTelephone(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      <span>{value}</span>
                                                    )}
                                                  </td>
                                                ) : (
                                                  <td
                                                    className="d-none"
                                                    key={key}
                                                  >
                                                    <input
                                                      type="hidden"
                                                      size="10"
                                                      value={value}
                                                    />
                                                  </td>
                                                )
                                            )}
                                            <td>
                                              <i
                                                className="bx bx-trash"
                                                style={{
                                                  fontSize: "20px",
                                                  paddingTop: "5px",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  onDeleteFormNumeroTelephone(
                                                    rowData.index
                                                  )
                                                }
                                              ></i>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr>
                                          <td colSpan="9">
                                            <input
                                              type="button"
                                              style={tableaustyles}
                                              className="btn btn-info mt-3 mt-lg-0"
                                              value="Ajouter"
                                              onClick={onAddFormNumeroTelephone}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      ) : // Si le type est égal à PM (Personne morale)
                      !loading &&
                        investisseursData?.detail_investisseur?.identification
                          .Type == "PM" ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Identification
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.identification
                                  ).map(([key, value], index) => (
                                    <Row className="mb-2">
                                      {key === "Dénomination sociale" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "wrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "11em",
                                                  paddingRight: "20px",
                                                  whiteSpace: "wrap",
                                                }}
                                              >
                                                {key}* :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control form-control-sm"
                                              value={denomSocial}
                                              onChange={(e) =>
                                                setDenomSocial(e.target.value)
                                              }
                                            />
                                            {denomSocial === "" ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Dénomination sociale ne peut pas
                                                être vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </>
                                      ) : key === "N° RCS" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control form-control-sm"
                                              value={numeroRcs}
                                              onChange={(e) =>
                                                setNumeroRcs(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Contact
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.contact
                                  ).map(([key, value], index) => (
                                    <Row className="mb-2">
                                      {key === "Téléphone" ? (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control form-control-sm"
                                              value={telephone}
                                              onChange={(e) =>
                                                setTelephone(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Fax" ? (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control form-control-sm"
                                              value={fax}
                                              onChange={(e) =>
                                                setFax(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Email" ? (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control form-control-sm"
                                              value={emailPm}
                                              onChange={(e) =>
                                                setEmailPm(e.target.value)
                                              }
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Caractéristique
                                </CardTitle>
                                <CardBody>
                                  {Object.entries(
                                    investisseursData?.detail_nom_investisseur
                                      ?.caracteristiques
                                  ).map(([key, value], index) => (
                                    <Row className="mb-2">
                                      {key === "Forme juridique" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              value={
                                                selectedForme?.label == null
                                                  ? null
                                                  : selectedForme
                                              }
                                              onChange={handleFormeChange}
                                              options={renderFormeOptions()}
                                              isClearable={true}
                                              className="select2"
                                              styles={styles(false)}
                                            />
                                          </Col>
                                        </>
                                      ) : // Président
                                      key === "Président (PM)" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={8}>
                                            <Select
                                              value={
                                                selectedPresidentPM?.label ==
                                                null
                                                  ? null
                                                  : selectedPresidentPM
                                              }
                                              onChange={handlePresidentChange}
                                              options={renderPresidentOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Directeur Général" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={8}>
                                            {/* Rendre les options directeurs */}
                                            <Select
                                              value={
                                                selectedDir?.label == null
                                                  ? null
                                                  : selectedDir
                                              }
                                              onChange={handleDirecteurChange}
                                              options={renderDirecteurOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </>
                                      ) : key === "Président (PP)" ? (
                                        <>
                                          <Col
                                            key={index}
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col xs={12} md={12} lg={8}>
                                            {/* Rendre les options directeurs */}
                                            <Select
                                              value={
                                                selectedPresidentPP?.label ==
                                                null
                                                  ? null
                                                  : selectedPresidentPP
                                              }
                                              onChange={handlePresidentPPChange}
                                              options={renderDirecteurOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            key={index}
                                            className="col-4"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>{key} :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {renderValue(value)}
                                            </span>
                                          </Col>
                                        </>
                                      )}
                                    </Row>
                                  ))}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="12">
                              <CardTitle
                                tag="h5"
                                style={{ paddingBottom: "10px" }}
                              >
                                Adresses
                              </CardTitle>
                              <div className="table-responsive">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      {investisseursData?.detail_nom_investisseur?.adresses?.Adresses.header.map(
                                        (columnName, index) => (
                                          <th
                                            className="text-nowrap"
                                            style={tableaustyles}
                                            key={index}
                                          >
                                            {columnName}
                                          </th>
                                        )
                                      )}
                                      <th
                                        className="text-nowrap"
                                        style={tableaustyles}
                                        key="Del"
                                      ></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {formAdressePostals.map(
                                      (rowData, index) => (
                                        <tr key={index}>
                                          {Object.entries(rowData).map(
                                            ([key, value]) =>
                                              key !== "id" &&
                                              key !== "index" ? (
                                                <td key={key}>
                                                  {key === "siege" ? (
                                                    <div>
                                                      <select
                                                        className="form-control form-control-sm"
                                                        style={{
                                                          minWidth: "50px",
                                                        }}
                                                        value={value}
                                                        name="siege"
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            rowData.index,
                                                            e.target.name,
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        {renderYesNoOptions()}
                                                      </select>
                                                      {value === "" ? (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          Siège ne peut pas être
                                                          vide
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  ) : key === "adresse" ||
                                                    key === "complement" ||
                                                    key === "code_postal" ||
                                                    key === "ville" ||
                                                    key === "pay_id" ||
                                                    key === "tel" ? (
                                                    <input
                                                      className="form-control form-control-sm"
                                                      style={{
                                                        minWidth:
                                                          key === "adresse"
                                                            ? "150px"
                                                            : "50px",
                                                      }}
                                                      value={value}
                                                      name={key}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          rowData.index,
                                                          e.target.name,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                              ) : (
                                                <td
                                                  key={key}
                                                  className="d-none"
                                                >
                                                  <input
                                                    type="hidden"
                                                    size="10"
                                                    value={value}
                                                  />
                                                </td>
                                              )
                                          )}
                                          <td>
                                            <i
                                              className="bx bx-trash"
                                              style={{
                                                fontSize: "20px",
                                                paddingTop: "5px",
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                onDeleteFormAdressePostalPM(
                                                  rowData.index
                                                )
                                              }
                                            ></i>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                    <tr>
                                      <td colSpan="9">
                                        <input
                                          type="button"
                                          style={tableaustyles}
                                          className="btn btn-info mt-3 mt-lg-0"
                                          value="Ajouter"
                                          onClick={onAddFormAdressePostalPM}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
}

export default InvestorDetail;
